import React from "react";
import { Link } from "react-router-dom";
import styles from "./PaymentInstallments.module.scss";

const PaymentInstallments = () => {
  return (
    <main className={styles.page}>
      {/* HERO SECTION */}
      {/* 
        TODO: Тут бажано додати офіційний банер monobank з брендбуку.
        Рекомендація: банер "Покупка частинами monobank" або hero-banner з guideline.
        Якщо є PNG/SVG з Figma — покласти в assets/images/mono-installments-banner.png
      */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.badge}>monobank</span>

          <h1 className={styles.title}>
            Покупка частинами monobank
          </h1>

          <p className={styles.subtitle}>
            Купуйте зараз, а сплачуйте щомісячно рівними частинами.
            Перший платіж списується під час оформлення покупки.
          </p>

          <Link to="/" className={styles.button}>
            Перейти до покупок
          </Link>
        </div>

        <div className={styles.heroBanner}>
          {/* 
            TODO: Замінити placeholder на офіційний банер з брендбуку mono.
            Приклад:
            <img src="/images/mono-installments-banner.png" alt="Покупка частинами monobank" />
          */}
            <img src="/theme/assets/payment/mono-installments-banner.png" alt="Покупка частинами monobank" />

          {/* <div className={styles.bannerPlaceholder}>
            Місце для офіційного банера monobank
          </div> */}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Як це працює?</h2>

        <div className={styles.steps}>
          <div className={styles.step}>
            <span>1</span>
            <p>Оберіть товари на сайті.</p>
          </div>

          <div className={styles.step}>
            <span>2</span>
            <p>На етапі оплати виберіть “Кредит та оплата частинами”.</p>
          </div>

          <div className={styles.step}>
            <span>3</span>
            <p>Оберіть кількість платежів.</p>
          </div>

          <div className={styles.step}>
            <span>4</span>
            <p>Підтвердіть покупку в застосунку monobank.</p>
          </div>
        </div>
      </section>

      {/* CONDITIONS */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Умови</h2>

        <div className={styles.conditionsGrid}>
          <div className={styles.conditionCard}>
            <strong>Сума розстрочки</strong>
            <p>від 1 грн до 400 000 грн</p>
          </div>

          <div className={styles.conditionCard}>
            <strong>Кількість платежів</strong>
            <p>на сайті доступно від 3 до 5 платежів</p>
          </div>

          <div className={styles.conditionCard}>
            <strong>Перший платіж</strong>
            <p>списується під час оформлення покупки</p>
          </div>

          <div className={styles.conditionCard}>
            <strong>Погашення</strong>
            <p>щомісячні платежі рівними частинами</p>
          </div>
        </div>
      </section>

      {/* BRAND IMAGE / BANNER */}
      <section className={styles.brandBlock}>
       
        <div className={styles.brandPlaceholder}>
            <img src="../../theme/assets/footer/black_full_logo_600_px.png" alt="Покупка частинами monobank" />

        </div>
      </section>

      {/* LEGAL INFO */}
      <section className={styles.legalSection}>
        <h2 className={styles.sectionTitle}>
          Юридична інформація
        </h2>

        <div className={styles.legalBox}>
          <p>
            <strong>Покупка частинами monobank | Universal Bank</strong>
          </p>

          <p>
            <strong>Надавач послуг:</strong> АТ «УНІВЕРСАЛ БАНК»,
            ліцензія НБУ №92 від 20.01.1994, номер у держреєстрі банків №226.
          </p>

          <p>
            <strong>Характеристики продукту:</strong>
          </p>

          <ul>
            <li>Мінімальна сума розстрочки: 1 грн</li>
            <li>Максимальна сума розстрочки: 400 000 грн</li>
            <li>Реальна річна процентна ставка: 0,000001%</li>
            <li>Доступний строк, платежів: 3 — 25</li>
            <li>Порядок погашення: щомісячні платежі рівними частинами</li>
            <li>Перший платіж у момент оформлення покупки</li>
          </ul>

          <p>
            Інформація про істотні характеристики продукту та попередження
            розміщені на сайті продукту{" "}
            <a
              href="https://chast.monobank.ua"
              target="_blank"
              rel="noreferrer"
            >
              chast.monobank.ua
            </a>
            .
          </p>
        </div>
      </section>
    </main>
  );
};

export default PaymentInstallments;